import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Form from '../form/Form';
import ApiService from '../../services/ApiService';

const getFormLayout = values => [
  {
    name: 'name',
    label: 'Name',
    data: values.name,
    required: true,
  },
  {
    name: 'pageName',
    label: 'Page',
    data: values.pageName,
    readOnly: true,
  },
  {
    name: 'optionsHash',
    hidden: true,
    data: values.optionsHash,
  },
  {
    name: 'options',
    hidden: true,
    data: values.options,
  },
  {
    name: 'description',
    label: 'Description',
    control: 'textarea',
    data: values.description,
  },
  {
    name: 'isPublic',
    label: 'Public',
    control: 'checkbox',
    data: values.isPublic,
    helpText: 'Other users will be able to use and copy this layout',
    options: [true, false],
    type: 'boolean',
    col: 6,
  },
  {
    name: 'saveNew',
    label: 'Save As New Layout',
    control: 'checkbox',
    data: values.saveNew,
    options: [true, false],
    type: 'boolean',
    col: 6,
    hidden: values.saveNew,
  },
  {
    name: 'layout',
    type: 'json',
    data: values.layout,
    hidden: true,
  },
];

const SaveGridLayoutForm = ({ values = {}, onSubmit, ...props }) => {
  const user = useSelector(state => state.app.user);
  const [gridLayout, setGridlayout] = useState(null);

  useEffect(() => {
    if (values.id) {
      ApiService.get(`grid-layouts/${values.id}`).then(response => {
        // new layout if the layout has a different owner or the layout options hash is different
        const saveNew =
          user.id !== response.data.userId ||
          (response.data.optionsHash && response.data.optionsHash !== values.optionsHash);

        setGridlayout({ ...response.data, options: values.options || null, optionsHash: values.optionsHash, saveNew });
      });
    }
  }, []);

  const handleSubmit = data => {
    if (!data.options || !data.optionsHash) {
      data.options = null;
      data.optionsHash = null;
    }

    if (values.id && !data.saveNew) {
      ApiService.put(`grid-layouts/${values.id}`, data).then(response => {
        onSubmit(response.data);
      });
    } else {
      delete data.id;
      delete data.saveNew;
      ApiService.post('grid-layouts', data).then(response => {
        onSubmit(response.data);
      });
    }
  };

  if (values.id && !gridLayout) {
    return null;
  }

  const formLayout = gridLayout
    ? getFormLayout({ ...gridLayout, layout: values.layout })
    : getFormLayout({ ...values, saveNew: true });

  return (
    <Form {...props} showHelp useTypedData layout={formLayout} submit={handleSubmit} submitAll exportFormat="object" />
  );
};

SaveGridLayoutForm.propTypes = {
  values: PropTypes.object,
  onSubmit: PropTypes.func,
};

export default SaveGridLayoutForm;
